




import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import QRCode from 'qrcode';

@Component
export default class Parts extends Vue {
  @Prop({ type: String, default: true })
  private text!: string;

  @Watch('text')
  private async handleText() {
    if (!this.$el) return;
    const canvas: HTMLCanvasElement = this.$el as HTMLCanvasElement;
    QRCode.toCanvas(canvas, this.text, { width: 200, margin: 0 });
  }

  private mounted(): void {
    this.handleText();
  }
}
